define('container/initialisers/FactoryInitialiser',[],function() {

    'use strict';

    /**
     * Calls the module with any args.
     *
     * Intended as the default so will attempt to initialise any service. It
     * should be included last in the list of initialisers.
     */
    function FactoryInitialiser() {
    }

    FactoryInitialiser.prototype.canInitialise = function(extensionApi) {
        return extensionApi.serviceDefinition.init === 'factory';
    };

    FactoryInitialiser.prototype.initialise = function(instanceCreatedCallback, loadedModule) {

        var instance = loadedModule.apply(null, Array.prototype.slice.call(arguments, 2));

        instanceCreatedCallback(instance);

        return instance;
    };

    return FactoryInitialiser;

});

